var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6447 13.6936L21.7685 13.5698L21.6447 13.4461L20.8076 12.6089L20.6839 12.4852L20.5601 12.6088L16.3522 16.8112V5.85107V5.67607H16.1772H14.9897H14.8147V5.85107V16.8112L10.6068 12.6088L10.4831 12.4852L10.3594 12.6089L9.52225 13.4461L9.39851 13.5698L9.52225 13.6936L15.4598 19.6311L15.5835 19.7548L15.7072 19.6311L21.6447 13.6936Z",
    fill: "#214ba5",
    stroke: "#214ba5",
    strokeWidth: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.521 18.7386H21.346V18.9136V21.1136H9.821V18.9136V18.7386H9.646H8.4585H8.2835V18.9136V21.2886C8.2835 21.6499 8.42704 21.9965 8.68256 22.252C8.93808 22.5075 9.28464 22.6511 9.646 22.6511H21.521C21.8824 22.6511 22.2289 22.5075 22.4844 22.252C22.7399 21.9965 22.8835 21.6499 22.8835 21.2886V18.9136V18.7386H22.7085H21.521Z",
    fill: "#214ba5",
    stroke: "#214ba5",
    strokeWidth: 0.35
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.26ad567d107e8bcfbf0ff0cb25d16e0a.svg";
export { ForwardRef as ReactComponent };